package empiresmp.components.alert

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.CSSTransition
import com.varabyte.kobweb.compose.css.TouchAction
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.touchAction
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.silk.components.overlay.Overlay
import empiresmp.components.fade.animation.Animatable
import empiresmp.components.fade.animation.InterpolateAnimator
import org.jetbrains.compose.web.css.s
import kotlin.time.Duration.Companion.milliseconds

@Composable
fun ClosableOverlay(
    open: Boolean,
    content: @Composable () -> Unit
) {
    val animatable = remember { Animatable(0f) }
    LaunchedEffect(open) {
        if (open) {
            animatable.animateTo(1f, InterpolateAnimator(300.milliseconds))
        } else {
            animatable.animateTo(0f, InterpolateAnimator(300.milliseconds))
        }
    }
    if (animatable.value != 0f) {
        ClosableTransitionObject(open = open) { transitionModifier ->
            Overlay(
                transitionModifier
                    .opacity(animatable.value)
                    .transition(CSSTransition("background-color", 0.3.s, TransitionTimingFunction.Linear))
                    .touchAction(TouchAction.None)
                    .zIndex(1000),
                contentAlignment = Alignment.Center
            ) {
                content()
                // has to be inside overlay because of deferred render logic
                LaunchedEffect(Unit) {
                    animatable.animateTo(1f, InterpolateAnimator(300.milliseconds))
                }
            }
        }
    }
}
